import api from "./baseApi.js";

export default {

    GetCommercials(fCompanyCode, companyCode) {
        let arg = { fCompanyCode, companyCode };

        return api.post("Commercials/GetCommercials", arg);
    },

    IsAdmin(mail) {
        return api.get("Main/IsAdmin/" + mail);
    },

    GetDivisions() {
        return api.get("Main/GetDivisions");
    },

    GetCommunications(companyCode, username, read) {
        let arg = { companyCode, username, read };

        return api.post("Main/GetCommunications", arg);
    },

    SaveCommunication(communication) {
        return api.post("Main/SaveCommunication", communication);
    },

    SaveCommunicationDocument(arg) {
        return api.post("Main/SaveCommunicationDocument", arg);
    },

    GetCommunicationsFiltered(filter) {
        return api.post("Main/GetCommunicationsFiltered", filter);
    },

    GetCommunication(id) {
        return api.get("Main/GetCommunication/" + id);
    },

    ReadCommunication(id, username) {
        let arg = { id, username };
        return api.post("Main/ReadCommunication", arg);
    },

    GetMandatoryCommunications(companyCode, username) {
        let arg = { companyCode, username };

        return api.post("Main/GetMandatoryCommunications", arg);
    },


}